export const APP_VERSION = '2.6.0';
export const BUILD_DATE = new Date().toISOString().split('T')[0];
export const COPYRIGHT_YEAR = new Date().getFullYear();
